import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Rendimiento',
    [Tab.NewCustomers]: 'Nuevos restaurantes',
    [Tab.CustomerHealth]: 'Salud del cliente',
    [Tab.LiveAndInactive]: 'Activos e inactivos',
    [Tab.BillingHealth]: 'Salud de facturación',
  },
  labels: {
    sales_manager: 'Gerente de ventas',
  },
  performance_tab: {
    table_columns: {
      name: 'Nombre',
      sales_manager: 'Gerente de ventas',
      orders: 'Pedidos',
      sales: 'Ventas',
      previous_month_sales: 'Ingresos del mes anterior',
    },
    labels: {
      sales_volume: 'Volumen de ventas:',
      all: 'Todos',
      click_to_sort: 'Clic para ordenar',
      no_data: 'Sin datos',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nombre',
      sales_manager: 'Gerente de ventas',
      orders: 'Pedidos',
      sales: 'Ventas',
      days_live: 'Días activo',
      early_performance: 'Rendimiento inicial',
    },
    labels: {
      click_to_sort: 'Clic para ordenar',
      no_data: 'Sin datos',
      only_with_early_performance: 'Solo con rendimiento inicial: ',
      early_performance_yes: '✔️ Sí',
      early_performance_no: '✗ No',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Niveles de ventas',
      payments_ratio: 'Ratio de pagos',
    },
    dataset_labels: {
      negative: 'Negativo ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Bueno ({{values}})',
      excellent: 'Excelente ({{values}})',
    },

    companies_preview_modal: {
      title: 'Vista previa de restaurantes',
      table_columns: {
        name: 'Nombre',
        sales_manager: 'Gerente de ventas',
        orders: 'Pedidos',
        sales: 'Ventas',
        total_payments: 'Pagos totales',
        payments_ratio: 'Ratio de pagos',
      },
      labels: {
        close: 'Cerrar',
        click_to_sort: 'Clic para ordenar',
        no_data: 'Sin datos',
      },
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Activo',
      no_orders: 'Sin pedidos',
      no_conversion: 'Sin conversión',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Tipo de facturación',
        options: {
          [BillingTypeOptions.Subscription]: 'Suscripción',
          [BillingTypeOptions.Manual]: 'Otro',
        },
      },
      high_risk_only: {
        label: 'Solo clientes de alto riesgo',
      },
    },
    fields: {
      name: 'Nombre',
      live_from: 'Activo desde',
      billing_mode: {
        title: 'Fuente de facturación',
        options: {
          [BillingMode.Stripe]: 'Método de pago',
          [BillingMode.InternalInvoicing]: 'Ventas',
        },
      },
      trial_ends_at: 'Fin de prueba',
      last_failed_invoice_amount: 'Importe de última factura fallida',
      failed_payments_count: 'Número de pagos fallidos',
    },
    tags: {
      is_high_billing_risk_customer: 'Alto riesgo de facturación',
    },
    toasts: {
      failed_to_load_data: 'Error al cargar los datos',
    },
  },
};
